import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import { ProjectType, ProjectTypeStatus } from '../../../models/instance/project-type.model';
import { CreateProjectTypeStatusModalComponent } from '../../modals/organization/create-project-type-status-modal/create-project-type-status-modal.component';

@Component({
    selector: 'app-instance-project-type-status',
    templateUrl: './instance-project-type-status.component.html',
    styleUrls: ['./instance-project-type-status.component.scss'],
    standalone: false
})
export class InstanceProjectTypeStatusComponent implements OnInit {
    @Input() currentProjectType: ProjectType;
    @Input() projectTypeStatusTypeList: ProjectTypeStatus[];
    @ViewChild(MatTable) table: MatTable<any>;
    @Output() newStatusColor = new EventEmitter<ProjectTypeStatus[]>();

    tooltip_position = 'above';
    displayedColumns: string[] = ['statusName', 'color'];
    projectTypeTemp: ProjectTypeStatus[];
    dataSource;
    tempObj: ProjectTypeStatus[];
    temp1 = [];
    projectTypeStatusList: ProjectTypeStatus[];

    constructor(private ngbModal: NgbModal) {}

    ngOnInit(): void {
        this.dataSource = new MatTableDataSource<ProjectTypeStatus>(this.projectTypeStatusTypeList);
    }

    addNewProjectTypeStatus() {
        let dialogRef = this.ngbModal.open(CreateProjectTypeStatusModalComponent, {
            size: 'md',
        });
        dialogRef.componentInstance.modalMode = 'add';
        dialogRef.componentInstance.defaultStatusList = this.projectTypeTemp;
        dialogRef.result
            .then((result) => {
                if (result) {
                    this.tempObj.push(result);
                    this.projectTypeTemp.push(result);
                    this.table.renderRows();
                    this.newStatusColor.emit(this.projectTypeTemp);
                }
            })
            .catch((error) => {
                console.warn(error);});
    }

    temp(element, event) {
        let index = this.findIndexOfActivityTypeStatus(element.name, this.tempObj);
        let otherIndex = this.findIndexOfActivityTypeStatus(element.name, this.projectTypeTemp);
        this.projectTypeTemp[otherIndex] = this.tempObj[index];
        this.newStatusColor.emit(this.projectTypeTemp);
    }

    deleteProjectTypeStatus(projectTypeStatus: ProjectTypeStatus) {
        // let dialogRef = this.ngbModal.open(DeleteDialogComponent, {
        //   size: "sm",
        // });
        // let index = this.findIndexOfActivityTypeStatus(
        //   projectTypeStatus.name,
        //   this.tempObj
        // );
        // let otherIndex = this.findIndexOfActivityTypeStatus(
        //   projectTypeStatus.name,
        //   this.projectTypeTemp
        // );
        // dialogRef.componentInstance.modalMessage = `<p>Do you want to delete <b>${projectTypeStatus.name}</b> activity pack status? </p>`;
        // dialogRef.result
        //   .then((result: ProjectTypeStatus) => {
        //     if (result) {
        //       if (projectTypeStatus.statusId) {
        //         projectTypeStatus.active = false;
        //         this.projectTypeTemp[otherIndex] = projectTypeStatus;
        //         this.tempObj.splice(index, 1);
        //         this.table.renderRows();
        //         this.newStatusColor.emit(
        //           JSON.parse(JSON.stringify(this.projectTypeTemp))
        //         );
        //       } else {
        //         this.tempObj.splice(index, 1);
        //         this.table.renderRows();
        //       }
        //     }
        //   })
        //   .catch((error) => {});
    }

    // helper method to get the index of particular activity type
    findIndexOfActivityTypeStatus(projectTypeStatusName: string, projectTypeStatusArray: ProjectTypeStatus[]) {
        let index = -1;
        for (const [index, projectTypeStatus] of projectTypeStatusArray.entries()) {
            if (projectTypeStatus.name.toLocaleLowerCase().replace(/ /g, '') === projectTypeStatusName.toLocaleLowerCase().replace(/ /g, '')) {
                return index;
            }
        }
        return index;
    }

    // function to view activity pack status
    viewStatusDetails(projectStatus: ProjectTypeStatus) {
        let dialogRef = this.ngbModal.open(CreateProjectTypeStatusModalComponent, {
            size: 'md',
        });
        dialogRef.componentInstance.modalMode = 'edit';
        let index = this.findIndexOfActivityTypeStatus(projectStatus.name, this.tempObj);
        let otherIndex = this.findIndexOfActivityTypeStatus(projectStatus.name, this.projectTypeTemp);
        dialogRef.componentInstance.projectTypeStatusList = projectStatus;
        dialogRef.componentInstance.defaultStatusList = this.projectTypeTemp;
        dialogRef.result
            .then((result) => {
                if (result) {
                    this.tempObj[index] = result;
                    this.projectTypeTemp[otherIndex] = result;
                    this.table.renderRows();
                    this.newStatusColor.emit(this.projectTypeTemp);
                }
            })
            .catch((error) => {
                console.warn(error);});
    }
}
